/* Styles for disclosure.tsx */

.disclosure__trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: rgb(var(--fg-muted));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.disclosure__trigger:hover {
  color: rgb(var(--fg));
}

.disclosure__icon {
  width: 0.875rem;
  height: 0.875rem;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.group[data-state="open"] .disclosure__icon {
  transform: rotate(90deg);
}

.disclosure__content {
  overflow: hidden;
}

.disclosure__content[data-state="closed"] {
  animation: collapsible-up 150ms ease-in;
}

.disclosure__content[data-state="open"] {
  animation: collapsible-down 180ms ease-out;
}

.disclosure__block {
  padding-top: 0.5rem;
}
